// extracted by mini-css-extract-plugin
export const blogList = "blogList-module--blogList--UZUdB";
export const sectionContainer = "blogList-module--sectionContainer--gvR20";
export const richtext = "blogList-module--richtext--2lnw-";
export const listWrapper = "blogList-module--listWrapper--xN6JU";
export const itemWrap = "blogList-module--itemWrap--2ZHmO";
export const imageWrap = "blogList-module--imageWrap--29CWC";
export const contentTitle = "blogList-module--contentTitle--2zyfK";
export const contentTextWrap = "blogList-module--contentTextWrap--3Yz_E";
export const description = "blogList-module--description--3SoVe";
export const tabWrapper = "blogList-module--tabWrapper--31BMp";
export const tabLabelWrap = "blogList-module--tabLabelWrap--BGZV6";
export const tabLabel = "blogList-module--tabLabel--2V5jA";
export const tabLabel__active = "blogList-module--tabLabel__active--3BEJL";
export const mobileTabSelect = "blogList-module--mobileTabSelect--sWCLn";
export const mobileTabValue = "blogList-module--mobileTabValue--2V3kc";
export const mobileTabOptions = "blogList-module--mobileTabOptions--22ZC8";
export const mobileTabOptions__active = "blogList-module--mobileTabOptions__active--2Rfzd";
export const tabOption = "blogList-module--tabOption--nUltA";